import { AuthTokenPayload } from './AuthTokenPayload'

export class AuthTokenFactory {
  static getToken(): string | null {
    return (
      new URLSearchParams(window.location.search).get('token')
    )
  }

  static getPayload(): AuthTokenPayload | null {
    try {
      const token = this.getToken()
      if (!token) return null
      return JSON.parse(atob(token.split('.')[1]))
    } catch {
      return null
    }
  }

  static isAgent(): boolean {
    const payload = this.getPayload()
    return !!payload?.agent
  }

  static getCustomerId(): string | null {
    const payload = this.getPayload()
    return payload?.customerId ?? null
  }
}
